import {Injectable, Inject} from '@angular/core';
import { OdometerService } from '../odometer.service';
import * as Odometer from 'odometer';
import { DOCUMENT } from '@angular/platform-browser';

@Injectable()
export class BrowserOdometerService extends OdometerService {

  constructor(
    @Inject(DOCUMENT) private document,
  ) { super(); }

  public init(selector: string, initValue: number, firstUpdate: number) {
      const odometer = new Odometer({
        el: this.document.querySelector(selector),
        value: initValue 
      });
      odometer.update(firstUpdate);
  }

}
